import { fadeInAndOut, fadeAnimation } from './SkeletonFadeInAndOut';

export { fadeAnimation };
export default fadeInAndOut;
